"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.ClearBasketEvent = void 0;
const Name = exports.Name = 'clear-basket';
const ClearBasketEvent = exports.ClearBasketEvent = Name;
//# sourceMappingURL=index.js.map